import React, { useState } from "react";
import { Box } from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import { getCellStyle } from "../../../Utils/DecideColor";
import { Input, Tooltip } from "reactstrap";
import { getConsumptionRule } from "./resourcePayload";
import StatusBadge from "../../../Customers/StatusBadge";

export const ResourcecolumnData = (isCurrency, selectAllResource, setSelectAllResource, resources, setSelectedResource, selectedResource, checkboxRef, isMobile, modalOpen, tooltipOpen, setTooltipOpen) => {
  const toggle = (index) => {
    setTooltipOpen((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const MONETARY_STATUS_THEME = {
    "non-monetary": {
      bg: "#EEEEEE",
      color: "#000000",
      iconBg: "#000000",
      Icon: null,
      border: `1px solid #00000020`, // Added border similar to StatusBadge
      px: 1.5, // Added padding similar to StatusBadge
      py: 0.5, // Added padding similar to StatusBadge
      borderRadius: 1, // Added border radius similar to StatusBadge
    },
    monetary: {
      bg: "#EEEEEE",
      color: "#000000",
      iconBg: "#000000",
      Icon: null,
      border: `1px solid #00000020`, // Added border similar to StatusBadge
      px: 1.5, // Added padding similar to StatusBadge
      py: 0.5, // Added padding similar to StatusBadge
      borderRadius: 1, // Added border radius similar to StatusBadge
    },
  };

  return [
    {
      accessorKey: 'checkbox',
      header: 'checkbox',
      muiTableHeadCellProps: { sx: { order: -2, paddingRight: '0px', maxWidth: "10px" } },
      muiTableBodyCellProps: { sx: { order: -2, paddingRight: '0px', maxWidth: "10px" } },
      Header: ({ row }) => (
        <Input type="checkbox" ref={checkboxRef} className='rv-table-checkbox' checked={selectAllResource} style={{ borderWidth: '2px', borderColor: '#000', borderRadius: '0' }} onClick={() => {
          setSelectAllResource(!selectAllResource)
          if (!selectAllResource) {
            setSelectedResource(resources) // Fixed: was "customers", should be "resources"
          }
          else {
            setSelectedResource([])
          }
        }} />
      ),
      enableColumnFilter: false,
      enableColumnActions: false,
      enableColumnDragging: false,
      Cell: ({ row }) => (
        <Input readOnly type="checkbox" className='rv-table-checkbox' checked={selectedResource.some(p => p.name === row.original.name)} style={{ borderWidth: '2px', borderColor: '#000', borderRadius: '0' }} onClick={() => {
          handleCheckboxChange(row, selectedResource, setSelectedResource)
        }
        } />
      ),
      size: isMobile ? 50 : modalOpen ? 50 : 50
    },
    {
      accessorKey: "name",
      header: "Resource Name",
      size: 190,
    },
    {
      accessorKey: "resourceType",
      accessorFn: (resource, index) => `${isCurrency[index]}`,
      header: "Resource Type",
      size: 190,
      Cell: ({ cell }) => {
        const value = cell.getValue();
        // Convert the value to a format that StatusBadge can understand
        const statusValue = value.toLowerCase().includes('monetary') ? 'monetary' : 'non-monetary';

        return (
          <StatusBadge
            value={value}
            customTheme={MONETARY_STATUS_THEME[statusValue]}
          />
        );
      },
    },
    {
      accessorKey: "resourceId",
      header: "Code",
      size: 150,
    },
    {
      accessorKey: "ceiling",
      header: "Ceiling",
      size: 150,
    },
    {
      accessorKey: "floor",
      header: "Floor",
      size: 150,
    },
    {
      accessorKey: "consumptionRule",
      header: "Consumption Rule",
      Cell: ({ cell }) => {
        const cellValue = getConsumptionRule(cell.getValue());
        const word = cellValue.split(" ");
        return (
          <div key={cell.row.index}>
            <p>
              <a id={`TooltipExample_${cell.row.index}`}>
                {word.slice(0, 3).join(' ')}
                {word.length > 3 && <span>...</span>}
              </a>
            </p>
            {word.length > 3 && <Tooltip className="tooltip-border-radius"
              autohide={true}
              isOpen={!!tooltipOpen[cell.row.index]}
              target={`TooltipExample_${cell.row.index}`}
              toggle={() => toggle(cell.row.index)}
            >
              {cellValue}
            </Tooltip>}
          </div>
        );
      },
      size: 210,
    },
  ];
};

export const handleCheckboxChange = (row, selectedResource, setSelectedResource) => {
  let isChecked = selectedResource.some(p => p.name === row.original.name);
  let updatedSelectedResource = isChecked
    ? selectedResource.filter(p => p.name !== row.original.name)
    : [...selectedResource, row.original];
  setSelectedResource(updatedSelectedResource);
};